import { ProgramsTable } from "./ProgramsTable";

export const ProgramsView = () => {
  return <ProgramsTable />;
};
